import { getPartnerConfigs } from '../../config/partnerConfig'

const getPartnerConfigBySlug = (
  partnerSlug?: string,
  isAccountCreationV2?: boolean
) => {
  const configs = getPartnerConfigs(isAccountCreationV2)
  const foundConfigs = Object.values(configs).find((partner) => {
    if (Array.isArray(partner)) {
      return partner.find(
        (partnerConfig) => partnerConfig.config.partnerUrlSlug === partnerSlug
      )
    }

    return partner.config.partnerUrlSlug === partnerSlug
  })

  if (foundConfigs && !Array.isArray(foundConfigs)) {
    return [foundConfigs]
  }

  return foundConfigs || []
}

export default getPartnerConfigBySlug
